import { Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { translateIfKey } from "../../../domain/helper/i18n.helper";

@Pipe({ name: "translateIfKey", standalone: true, pure: false })
export class TranslateIfKeyPipe implements PipeTransform {
	constructor(private readonly translocoService: TranslocoService) {}

	transform(value: string, scope: string): string {
		if (!value) return value;
		return translateIfKey(this.translocoService, `${scope}.${value}`, value);
	}
}
